import { Flex } from 'antd';
import clsx from 'clsx';
import IF from 'common/if/IF';
import Tooltip from 'common/antd-tooltip/Tooltip';
import { Calender2Icon } from 'common/all-icons/custom-icons';
import DisplayDateTime from 'utils/time/display_time';
import styles from './DatePill.module.scss';

const DatePill = ({
  date,
  label = '',
  tooltip = '',
  icon,
  iconSize = 16,
  color = 'var(--ant-color-primary)',
  bgColor = 'var(--user-primary-light)',
  textColor = 'var(--user-main-text)',
  showIcon = true,
  className = '',
  formatter = DisplayDateTime,
}) => {
  const formattedDate = formatter(date);

  if (!formattedDate) return null;

  const tooltipTitle = [tooltip, formattedDate].filter(Boolean).join(': ');

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Tooltip title={tooltipTitle}>
        <Flex
          align="center"
          gap={4}
          className={styles.pill}
          style={{ '--pill-color': color, '--pill-bg': bgColor, '--pill-text': textColor }}
        >
          <IF condition={showIcon}>
            <span className={styles.icon}>{icon ?? <Calender2Icon className={'primary-text'} />}</span>
          </IF>
          <IF condition={label}>
            <span className={clsx('body-11-medium', styles.label)}>{label}</span>
          </IF>
          <span className={clsx('body-11-semibold', styles.date)}>{formattedDate}</span>
        </Flex>
      </Tooltip>
    </div>
  );
};

export default DatePill;
